import { EventViewData } from 'components/eventView/pages/eventData';

// Exhibitors   b652baa9-4cac-4f50-83f3-06bbc5d00586
// Speakers     a55033b6-99fe-49ad-a8f1-2b26a6ba257c
// Awards       9f3f5170-7d96-4189-afe3-10a5f81a4e28

export const CyclingEvent: EventViewData = {
    eventId: 'cycling',
    mapId: '46c59aca-be88-4e8f-94ce-53b48ea05f35',
    guideId: '033be180-7dcb-43ea-af02-671fc2c73153  ',
    eventInfo: {
        order: {
            mobile: [
                'home',
                '613c098f-ccb1-457f-ac9d-c15727be1820',
                'd63fc529-ef03-4d29-816e-0eab85d33054',
                'map',
                'information'
            ],
            wide: [
                'home',
                '613c098f-ccb1-457f-ac9d-c15727be1820',
                'd63fc529-ef03-4d29-816e-0eab85d33054',
                'information',
                'map'
            ],
            primes: ['613c098f-ccb1-457f-ac9d-c15727be1820'],
            normal: ['d63fc529-ef03-4d29-816e-0eab85d33054', 'information']
        }
    }
};
